import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { LoadingSpinnerModule } from 'shared/components'

import { CommentViewDialogComponent } from './comment-view-dialog.component'

@NgModule({
	declarations: [CommentViewDialogComponent],
	imports: [
		CommonModule,
		TranslateModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatDividerModule,
		LoadingSpinnerModule,
	],
	exports: [CommentViewDialogComponent],
})
export class CommentViewDialogModule {}
